module.exports = __webpack_public_path__ + "static/img/bc.9a5d4d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bc.png
// module id = jWWb
// module chunks = 1